import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import Request, { MEDIA_URL } from "../../request";
import Autosuggest from "react-autosuggest";
import moment from "moment";
import { Card, Spin, notification, Button, Tooltip, Row, DatePicker, Col, Input, Icon } from "antd";
import { TableComp } from "sz-react-utils";
import PDFFileView from "../../components/DocumentViews/PDFFileView";

const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {}
const dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY';
const { RangePicker } = DatePicker

const formatAmount = (amount, currency) => {
    return `${currency || "INR"} ${Number(amount || 0).toFixed(2)}`;
};
class ChannelPartnerAccountReport extends React.Component {
    state = {
        suggestions: [],
        value: "",
        loading: false,
        info: null,
        channelPartnerId: null,
        ext: null,
        linkUrl: null,
        time: null,
        branchs: [],
        totalPendingAmount: 0,
        count: 0,
        currency: null
    };


    loadBranches = () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ value: vv._id, text: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }


    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        });
    };

    onSuggestionsFetchRequested = async ({ value }) => {
        try {
            this.setState({ value });
            const response = await Request.handleSearchChannelPartner({
                searchField: value,
                results: 300,
            });

            const suggestions =
                (response.data || []).map((channelPartner) => ({
                    id: channelPartner._id,
                    text: `${channelPartner.channelPartnerName}`,
                }));

            if (this._isMounted) {
                this.setState({ suggestions });
            }
        } catch (err) {
            console.log(err);
        }
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    getSuggestionValue = (suggestion) => suggestion.text;

    renderSuggestion = (suggestion) => (
        <div>
            {suggestion.text}
        </div>
    );

    componentDidMount() {
        this._isMounted = true;
        this.loadBranches();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getUpdatedResponse = async () => {
        let params = {
            channelPartnerId: this.state.channelPartnerId
        }

        if (this.state.time) {
            params.time = this.state.time;
        }
        this.setState({ loading: true });
        const response = await Request.getUniversityCpStudentDetails(params);
        this.setState({
            info: response.data,
            loading: false,
            totalPendingAmount: response.totalPendingAmount,
            count: response.totalResults,
            currency: response.currency
        });
    }

    onSuggestionSelected = async (event, { suggestion }) => {
        try {
            this.setState({
                loading: true,
                value: suggestion.text,
                channelPartnerId: suggestion.id,
            });
            let payload = {
                channelPartnerId: suggestion.id
            }

            if (this.state.time) {
                payload.time = this.state.time;
            }
            const response = await Request.getUniversityCpStudentDetails(payload);

            this.setState({
                info: response.data,
                loading: false,
                totalPendingAmount: response.totalPendingAmount,
                count: response.totalResults,
                currency: response.currency
            });
        } catch (err) {
            this.setState({
                loading: false,
            });
        }
    };

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1]
                }
            }, () => {
                this.getUpdatedResponse();
            }
        )
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    getColumnSearchProps = (field, getValue) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${field}`}
                    value={selectedKeys[0]}
                    onChange={e =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => confirm()}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    size="small"
                    onClick={() => confirm()}
                >
                    Search
                </Button>
                <Button
                    size="small"
                    onClick={() => clearFilters()}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
            const data = getValue(record);

            return data
                ? data.toString().toLowerCase().includes(value.toLowerCase())
                : false;
        }
    });


    viewPDF = e => {

        let paymentUpload = e;
        let linkUrl = MEDIA_URL + paymentUpload;
        let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
        if (this.checkUrlExt(linkUrl)) {
            this.setState({ ext: ext, linkUrl: linkUrl });
        } else {
            notification.warning({
                message: 'File not exists!!!.'
            })
        }
    }
    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    render() {
        let { suggestions, value, loading, info, ext, linkUrl, branchs, totalPendingAmount, count, currency } = this.state;

        const inputProps = {
            placeholder: "Search Channel Partner",
            value,
            onChange: this.onChange,
        };

        const columns = [
            {
                title: '#',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Student Name',
                key: 'studentName',
                ...this.getColumnSearchProps(
                    'Student Name',
                    record => record.studentName
                )
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                render: (text, record) => (
                    <div>{record && record.dateOfBirth ? moment(record.dateOfBirth).format(dateFormat) : "N/A"}</div>
                )
            },
            {
                title: 'VID',
                key: 'id',
                ...this.getColumnSearchProps(
                    'VID',
                    record => record.id
                )
            },
            {
                title: 'University Name',
                key: 'universityName',
                render: (text, record) =>
                    record.visaDesk &&
                        record.visaDesk.selectedCourse
                        ? record.visaDesk.selectedCourse.universityInstitutionName
                        : "N/A",
                ...this.getColumnSearchProps(
                    'University Name',
                    record =>
                        record.visaDesk &&
                            record.visaDesk.selectedCourse
                            ? record.visaDesk.selectedCourse.universityInstitutionName
                            : ""
                )
            },
            {
                title: 'Course',
                key: 'course',
                render: (text, record) =>
                    record.visaDesk &&
                        record.visaDesk.selectedCourse
                        ? record.visaDesk.selectedCourse.courseName
                        : "N/A",

                ...this.getColumnSearchProps(
                    'Course',
                    record =>
                        record.visaDesk &&
                            record.visaDesk.selectedCourse
                            ? record.visaDesk.selectedCourse.courseName
                            : ""
                )
            },
            {
                title: 'Intake',
                key: 'intake',
                render: (text, record) => {
                    let courseStartDate = record && record.visaDesk && record.visaDesk.courseStartDate ? record.visaDesk.courseStartDate : null;
                    return (
                        <div>{courseStartDate ? moment(courseStartDate).format('MMM YYYY') : "N/A"}</div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'branch',
                render: (text, record) =>
                    record.branchDetails
                        ? record.branchDetails.branchName
                        : "N/A",

                ...this.getColumnSearchProps(
                    'Branch',
                    record =>
                        record.branchDetails
                            ? record.branchDetails.branchName
                            : ""
                )
            },
            {
                title: 'Term',
                key: 'invoiceProgress',
                render: (text, record) => (
                    <div>
                        <div>{record.invoiceProgress}</div>

                        {record.error ? (
                            <div
                                style={{
                                    color: '#ff4d4f',
                                    fontSize: '11px',
                                    marginTop: '2px',
                                    lineHeight: '14px'
                                }}
                            >
                                {record.error}
                            </div>
                        ) : null}
                    </div>
                )
            },
            {
                title: 'Amount (Bal)',
                key: 'totalPendingAmount',
                render: (text, record) => {
                    let currency =
                        record &&
                            record.visaDesk &&
                            record.visaDesk.selectedCourse &&
                            record.visaDesk.selectedCourse.currency
                            ? record.visaDesk.selectedCourse.currency
                            : null;

                    let finalAmount = formatAmount(record.totalPendingAmount, currency);

                    return (
                        <div>
                            <a
                                href={`/desk/getClaim?id=${record._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {finalAmount}
                            </a>
                        </div>
                    );
                }
            },
            {
                title: 'Offer Letter',
                key: 'offerLetter',
                render: (text, record) => {
                    const offerLetter = record && record.offerLetter ? record.offerLetter : null;
                    const url = offerLetter && offerLetter.url;

                    return url ? (
                        <Tooltip title="View Offer Letter">
                            <Button
                                type="primary"
                                size="small"
                                icon="eye"
                                onClick={() => this.viewPDF(url)}
                                style={{ background: '#52c41a', borderColor: '#52c41a' }}
                            />
                        </Tooltip>
                    ) : (
                        "N/A"
                    );
                }
            },
            {
                title: 'Visa Letter',
                key: 'visaLetter',
                render: (text, record) => {
                    const visaLetter = record && record.visaDesk && record.visaDesk.visaUpload && record.visaDesk.visaUpload[0] ? record.visaDesk.visaUpload[0] : null;
                    const url = visaLetter && visaLetter.url;

                    return url ? (
                        <Tooltip title="View Visa Letter">
                            <Button
                                type="primary"
                                size="small"
                                icon="eye"
                                onClick={() => this.viewPDF(url)}
                                style={{ background: '#52c41a', borderColor: '#52c41a' }}
                            />
                        </Tooltip>
                    ) : (
                        "N/A"
                    );
                }
            },
        ]
        return (
            <PageHeaderWrapper title="Channel Partner Account Report">
                {
                    ext != null && linkUrl !== null ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                <Card>
                    <Row>
                        <Col span={12}>
                            <Autosuggest
                                suggestions={suggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                onSuggestionSelected={this.onSuggestionSelected}
                                inputProps={inputProps}
                            />
                        </Col>
                        <Col span={12}>
                            {info ?
                                <>
                                    <h4>Filter by Intake</h4>
                                    <RangePicker
                                        format="YYYY-MM-DD"
                                        placeholder={['Start Date', 'End Date']}
                                        onChange={this.chooseRangerPicker}
                                        onOk={this.onOk}
                                    />
                                </>
                                : null}
                        </Col>
                    </Row>
                </Card>
                {
                    info && (
                        <Card bordered={true} style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", marginTop: '20px' }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {/* Total Results Section */}
                                <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: "12px", color: "#8c8c8c", textTransform: "uppercase", marginBottom: "4px" }}>
                                        Total Results
                                    </div>
                                    <div style={{ fontSize: "20px", fontWeight: "bold", color: "#1890ff" }}>
                                        {count ? count : 0}
                                    </div>
                                </div>

                                {/* Vertical Divider */}
                                {/* <div style={{ width: "1px", height: "40px", backgroundColor: "#f0f0f0" }} /> */}
                                {/* Total Pending Amount Section */}
                                {/* <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: "12px", color: "#8c8c8c", textTransform: "uppercase", marginBottom: "4px" }}>
                                        Total Pending Amount
                                    </div>
                                    <div style={{ fontSize: "20px", fontWeight: "bold", color: "#cf1322" }}>
                                        {currency ? currency : ""} {totalPendingAmount ? totalPendingAmount : 0}
                                    </div>
                                </div> */}

                            </div>
                        </Card>
                    )
                }

                <br />
                <Card>
                    <Spin spinning={loading}>
                        {info ? (
                            <div>
                                <TableComp
                                    columns={columns}
                                    // extraProps={{ scroll: { x: 3500 } }}
                                    ref={this.table}
                                    dataSource={info}
                                    // apiRequest={this.apiRequest}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 20,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'sans-serif' }}>Select a Channel Partner to view details.</div>
                        )}
                    </Spin>
                </Card>
            </PageHeaderWrapper>
        )
    }
}



export default ChannelPartnerAccountReport